/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminGetMoneyPoolRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminGetMoneyPoolResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminGetMoneyPool = (request:AdminGetMoneyPoolRequest, options?: CashRequestOptions) => post<AdminGetMoneyPoolRequest, AdminGetMoneyPoolResponse>("/2.0/cash/admin-get-money-pool", request, {...options, rejectOnError: true })